export const error500Text = "Hoppla, das sollte nicht passieren. Wir bitten um Entschuldigung! Vielleicht klappt es zu einem späteren Zeitpunkt wieder. Wenn nicht, dann bitte bei feedback@woodbook.info melden.";
